import { AufnahmeUndStand } from './AufnahmeUndStand';
import { KiAnbieter } from './KiAnbieter';
import { Einstufungsregeln } from './Einstufungsregeln';
import { Gewerkevorrang } from './Gewerkevorrang';
import { Gleichrangregeln } from './Gleichrangregeln';
import { Loesungsarten } from './Loesungsarten';
import { Toleranzen } from './Toleranzen';
import { Pflichtbauteile } from './Pflichtbauteile';
import { Planungsabschnitte } from './Planungsabschnitte';
import { Hoehenbaender } from './Hoehenbaender';

/**
 * Der Reiter „Grundlagen" (Batch 7) — Rahmenbedingungen: Aufnahme und Stand,
 * Regeln (mit den zwei neuen Karten Lösungsarten und Höhenbänder), nichts
 * davon ist ein Arbeitsvorrat. Komponiert nur bestehende und neue Karten,
 * hält selbst keinen Zustand.
 */
export function Grundlagen({
  projektId, ohneLauf, quellen, laeuft, onAufnehmen, meldung,
  suche, sucht, onSuchen,
  d,
}: {
  projektId: string;
  ohneLauf: boolean;
  quellen: any[];
  laeuft: string | null;
  onAufnehmen: (m: any) => void;
  meldung: string | null;
  suche: any;
  sucht: boolean;
  onSuchen: () => void;
  d: any;
}) {
  return (
    <>
      <AufnahmeUndStand
        projektId={projektId}
        ohneLauf={ohneLauf}
        quellen={quellen}
        laeuft={laeuft}
        onAufnehmen={onAufnehmen}
        meldung={meldung}
        suche={suche}
        sucht={sucht}
        onSuchen={onSuchen}
      />

      <KiAnbieter ki={d.ki} />
      <Einstufungsregeln regeln={d.regeln ?? []} />
      <Gewerkevorrang vorrang={d.vorrang ?? []} />
      <Gleichrangregeln regeln={d.gleichrangregeln ?? []} />
      <Loesungsarten loesungsarten={d.loesungsarten ?? []} />
      <Toleranzen einstellungen={d.einstellungen ?? []} />
      <Pflichtbauteile pflichtbauteile={d.pflichtbauteile ?? []} />
      <Planungsabschnitte bereiche={d.bereiche ?? []} />
      <Hoehenbaender hoehenbaender={d.hoehenbaender ?? []} />
    </>
  );
}
